var _desc, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMinimize(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/minimize") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/minimize",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: 12,
    cy: 12,
    r: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.74162879,11.5104267 L12.9171197,7.33516661 C13.1184303,7.13385598 13.4449962,7.13385598 13.6462859,7.33516661 L14.1333548,7.82221455 C14.3344347,8.02329439 14.3346445,8.3490001 14.1341941,8.55052054 L10.8249788,11.8750098 L14.1339842,15.1997089 C14.3346445,15.4012294 14.3342249,15.7269351 14.133124,15.9280359 L13.6460761,16.4150838 C13.4447655,16.6163945 13.1182205,16.6163945 12.9169099,16.4150838 L8.74162879,12.2395929 C8.54033914,12.0382823 8.54033914,11.7117374 8.74162879,11.5104267 Z",
    id: "left-chevron",
    fill: "#40B3DB",
    fillRule: "nonzero"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinimize);
export default __webpack_public_path__ + "static/media/minimize.c44fe3db.svg";
export { ForwardRef as ReactComponent };